import { ControlLabel, FormGroup, SelectPicker } from 'rsuite';
import { MonitoramentoTipo } from '../../types';
import styles from './MonitoringTypeForm.module.scss';

type MonitoringTypeFormProps = {
  value: string | null;
  onChange: (value: string | null) => void;
};

const MONITORING_TYPE_OPTIONS = [
  { label: 'Competitividade de Produto', value: MonitoramentoTipo.COMPETITIVIDADE_PRODUTO },
  { label: 'Competitividade de Varejo', value: MonitoramentoTipo.COMPETITIVIDADE_VAREJO },
];

export const MonitoringTypeForm = ({ value, onChange }: MonitoringTypeFormProps) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Tipo de monitoramento</h2>
      <FormGroup className={styles.formGroup}>
        <ControlLabel className={styles.label}>Selecione o tipo de Monitoramento</ControlLabel>
        <SelectPicker
          className={styles.select}
          data={MONITORING_TYPE_OPTIONS}
          value={value}
          onChange={onChange}
          placeholder="Competitividade de Produto"
          searchable={false}
          cleanable={false}
          block
        />
      </FormGroup>
    </div>
  );
};
